

import { Vue, Component, Prop } from 'vue-property-decorator'
import { Communicate } from '../../types/supplier'
import { Page } from '../../types/common'
import { CommunicateTypeName } from '@/utils/enum'

@Component
export default class SupplierCommunicate extends Vue {
  @Prop() readonly id!: string;

  page = 1
  size = 10
  total = 0
  loading = false
  tableData: Communicate[] = []

  communicateTypeName = CommunicateTypeName

  created () {
    this.loadData()
  }

  loadData () {
    this.loading = true
    this.$axios.get<Page<Communicate>>(this.$apis.supplier.communicateByPage, {
      page: this.page,
      size: this.size,
      supplierId: this.id
    }).then(res => {
      this.total = res.total
      this.tableData = res.list
    }).finally(() => {
      this.loading = false
    })
  }

  deleteCommunicate (communicateId: string) {
    this.$confirm('提示', '确认删除该条数据吗？').then(() => {
      this.$axios.post(this.$apis.supplier.deleteCommunication, {
        communicateId
      }).then(() => {
        this.loadData()
      })
    })
  }
}
